export const VISA_TYPE_OPTIONS = [
  'Study Visa',
  'Dependent Visa',
  'Visit Visa',
  'Work Visa',
];

export const VISA_STATUS_OPTIONS = [
  'In Progress',
  'Applied',
  'Approved',
  'Rejected',
  'Reapplied',
];

export const YES_NO_NOT_REQUIRED = ['Yes', 'No', 'Not Required'];
export const YES_NO_OPTIONS = ['Yes', 'No'];

export const VISA_DOCUMENT_TYPES = [
  'Passport',
  'Birth Certificate',
  'FRC',
  'Bank Statement',
  'Educational Docs',
  'Passport Pics',
  'Final Offer Letter',
  'Sponsor Documents',
  'Other',
];

export const emptyVisaForm = () => ({
  applicantName: '',
  applicantEmail: '',
  applicantPhone: '',
  countryId: '',
  visaType: 'Study Visa',
  mainApplicantName: '',
  mainApplicantRelation: '',
  mainApplicantInstitute: '',
  mainApplicantVisaCategory: '',
  mainApplicantVisaStatus: '',
  visaCategory: '',
  visaStatus: 'In Progress',
  submissionDate: '',
  visaAppointment: '',
  visaAppointmentDate: '',
  biometrics: '',
  biometricsAppointmentDate: '',
  medicalTest: '',
  medicalBooked: '',
  medicalAppointmentDate: '',
  bankStatementRequirement: '',
  bankStatementAmountRequired: '',
  submittedBy: '',
  visaNumber: '',
  institute: '',
  accommodationBooked: '',
  visaLink: '',
  visaWebsiteId: '',
  visaPassword: '',
});

export const mapVisaFromApi = (visa) => {
  const appointmentDate = visa.visa_appointment_date
    ? String(visa.visa_appointment_date).split('T')[0]
    : '';
  return {
    applicantName: visa.applicant_name || visa.student_name || '',
    applicantEmail: visa.applicant_email || visa.student_email || '',
    applicantPhone: visa.applicant_phone || visa.student_mobile || '',
    countryId: visa.country_id ? String(visa.country_id) : '',
    visaType: visa.visa_type || 'Study Visa',
    mainApplicantName: visa.main_applicant_name || '',
    mainApplicantRelation: visa.main_applicant_relation || '',
    mainApplicantInstitute: visa.main_applicant_institute || '',
    mainApplicantVisaCategory: visa.main_applicant_visa_category || '',
    mainApplicantVisaStatus: visa.main_applicant_visa_status || '',
    visaCategory: visa.visa_category || '',
    visaStatus: visa.visa_status || 'In Progress',
    submissionDate: visa.submission_date ? String(visa.submission_date).split('T')[0] : '',
    // Backfill Yes when an older record only has a date stored
    visaAppointment: visa.visa_appointment || (appointmentDate ? 'Yes' : ''),
    visaAppointmentDate: appointmentDate,
    biometrics: visa.biometrics || '',
    biometricsAppointmentDate: visa.biometrics_appointment_date
      ? String(visa.biometrics_appointment_date).split('T')[0] : '',
    medicalTest: visa.medical_test || '',
    // Backfill Yes when an older record has medical details but no medical_booked value
    medicalBooked: visa.medical_booked
      || ((visa.medical_test || visa.medical_appointment_date) ? 'Yes' : ''),
    medicalAppointmentDate: visa.medical_appointment_date
      ? String(visa.medical_appointment_date).split('T')[0] : '',
    bankStatementRequirement: visa.bank_statement_requirement || '',
    bankStatementAmountRequired: visa.bank_statement_amount_required || '',
    submittedBy: visa.submitted_by || '',
    visaNumber: visa.visa_number || '',
    institute: visa.institute || '',
    accommodationBooked: visa.accommodation_booked || '',
    visaLink: visa.visa_link || '',
    visaWebsiteId: visa.visa_website_id || '',
    visaPassword: visa.visa_password || '',
  };
};
